module.exports = __webpack_public_path__ + "ring-finished.png?c47dde20b5ecb8c9ba12175b65e6104b";